import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Star, Sparkles } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-gradient-to-b from-sky-50 to-white pt-20 pb-16 md:pt-28 md:pb-24" data-id="element-15">
      {/* Decorative background elements */}
      <div className="absolute top-20 left-10 text-yellow-300 opacity-50 animate-pulse" data-id="element-16">
        <Star size={48} fill="currentColor" data-id="element-17" />
      </div>
      <div className="absolute top-40 right-20 text-pink-300 opacity-50 animate-bounce duration-[3000ms]" data-id="element-18">
        <Star size={32} fill="currentColor" data-id="element-19" />
      </div>
      <div className="absolute bottom-20 left-1/4 text-sky-200 opacity-60" data-id="element-20">
        <Sparkles size={40} data-id="element-21" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-22">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-23">
          <div className="lg:w-1/2 text-center lg:text-left" data-id="element-24">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-25">
              <span className="inline-block px-4 py-1.5 rounded-full bg-yellow-100 text-yellow-800 font-semibold text-sm mb-6 border border-yellow-200" data-id="element-26">
                Para Docentes de Nivel Inicial
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-tight mb-6" data-id="element-27">
                Mega Pack de Recursos para Docentes de Nivel Inicial
              </h1>
              <p className="text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-600 mb-6" data-id="element-28">
                Más calma, más organización y recursos listos para usar durante
                todo el año (sin improvisar)
              </p>
              <p className="text-lg md:text-xl text-slate-600 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-29">
                El sistema completo para docentes que quieren dejar de
                improvisar, recuperar sus fines de semana y disfrutar de
                enseñar.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-30">
                <CTAButton href="#pricing" data-id="element-31" />
              </div>
              <p className="mt-4 text-sm text-slate-500 flex items-center justify-center lg:justify-start gap-2" data-id="element-32">
                <Star className="w-4 h-4 text-yellow-400 fill-current" data-id="element-33" />
                <span data-id="element-34">
                  +250 ideas listas para agregar a tus planificaciones
                </span>
              </p>
            </motion.div>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-35">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9,
            rotate: 2
          }} animate={{
            opacity: 1,
            scale: 1,
            rotate: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="relative" data-id="element-36">
              <div className="absolute inset-0 bg-gradient-to-tr from-yellow-200 to-pink-200 rounded-3xl transform rotate-3 scale-105 blur-xl opacity-50" data-id="element-37"></div>
              <img src="https://cdn.magicpatterns.com/uploads/vsqznns4BVTfnXDNCfGR9z/MOCKUP.png" alt="Mega Pack de Recursos para Docentes de Nivel Inicial" className="relative rounded-2xl shadow-2xl w-full border-4 border-white" data-id="element-38" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}